<template>
  <div class="dimmer">
    <div class="ui long modal"  style="display:block !important; top: unset">
      <div class="header">{{header}}</div>
      <div class="scrolling content">
        <slot></slot>
      </div>
      <div class="actions">
        <div v-if="footerText" style="display:inline-block" :style="footerTextStyle">{{footerText}}</div>
        <button  class="ui primary approve button" :class="{disabled: disabledApplyBtn}" @click.prevent.stop="$emit('apply')">
          {{applyBtnName}}
        </button>
        <button v-if="!hideCancel" class="ui cancel button" @click.prevent.stop="$emit('cancel')">
          {{cancelBtnName}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
      name:"elastic-dialog",
    //передоваемые параметры
    props: ['header','disabledApplyBtn','applyBtnName','cancelBtnName','hideCancel','footerText','footerTextStyle'],
    // локальное состояние
    data() {
      return {

      }
    },
    methods:{

    },

  }
</script>

<style scoped>
 .dimmer{
   position: fixed;
   top: 0 !important;
   left: 0 !important;
   width: 100%;
   height: 100%;
   text-align: center;
   vertical-align: middle;
   background-color: rgba(0, 0, 0, 0.85);
   z-index: 1000;
   display: flex;
   align-items: center;
   justify-content: center;
 }
</style>
